export const routesConfig = {
    entry: '/app',
    list: '/list',
    detail: '/details/:leadId',
    fallback: '/app/*',
    redirect: '/app/list',
};
